export default __webpack_public_path__ + "static/media/medical-1.2b22ee02.jpg";